import React from "react";
import { Instagram, Music2, MessageCircle } from "lucide-react";
import RimMark from "@/components/RimMark";
import { LINKS, NAV } from "@/lib/links";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      id="contatti"
      className="bg-rim-deep text-rim-text pt-16 md:pt-20 pb-8"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-10 border-b border-white/10">
          <div className="md:col-span-5">
            <RimMark variant="dark" size="lg" />
            <p className="mt-5 max-w-md text-[#6b6080] text-sm leading-relaxed">
              Social media agency italiana. Contenuti verticali, gestione
              social organica e crescita digitale per attività locali e brand.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <a
                href={LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-instagram"
                aria-label="Instagram"
                className="text-rim hover:text-rim-glow transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={LINKS.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-tiktok"
                aria-label="TikTok"
                className="text-rim hover:text-rim-glow transition-colors"
              >
                <Music2 className="h-5 w-5" />
              </a>
              <a
                href={LINKS.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-whatsapp"
                aria-label="WhatsApp"
                className="text-rim hover:text-rim-glow transition-colors"
              >
                <MessageCircle className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-[#6b6080] font-semibold mb-4">
              Naviga
            </p>
            <ul className="space-y-2.5">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    data-testid={`footer-nav-${n.href.replace("#", "")}`}
                    className="text-sm text-[#9b8fc0] hover:text-white transition-colors"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-[#6b6080] font-semibold mb-4">
              Contatti
            </p>
            <ul className="space-y-2.5">
              <li>
                <a
                  href={LINKS.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-contact"
                  className="inline-flex items-center gap-2 text-sm text-[#9b8fc0] hover:text-white"
                >
                  <Instagram className="h-4 w-4" />
                  @rimfluences
                </a>
              </li>
              <li>
                <a
                  href={LINKS.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="inline-flex items-center gap-2 text-sm text-[#9b8fc0] hover:text-white"
                >
                  <MessageCircle className="h-4 w-4" />
                  WhatsApp diretto
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#6b6080]">
          <p data-testid="footer-copyright">
            © {year} Rimfluences · P.IVA [—] ·{" "}
            <a href="#" data-testid="footer-privacy" className="hover:text-rim-glow">
              Privacy Policy
            </a>
          </p>
          <p>Made in Italy</p>
        </div>
      </div>
    </footer>
  );
}
